import { Fields as Merchant } from 'models/Merchant'
import { selectCurrentMerchant } from 'selectors/merchant'

export default (state?: Object): Merchant => {
  if (!state) return {} as Merchant

  return selectCurrentMerchant(state)
}
